import React from 'react';
import { Box, Typography } from '@mui/material';
import { businessInfo } from '../config/info';

/**
 * Visible, on-page copy for Valparai / Sholayar Dam local intent (not hidden text).
 */
const LocalSeoSection = () => (
  <Box
    component="section"
    aria-labelledby="local-seo-heading"
    sx={{
      py: { xs: 6, md: 8 },
      px: 3,
      bgcolor: 'var(--color-sand)',
      borderTop: '1px solid rgba(44,41,38,0.06)',
      borderBottom: '1px solid rgba(44,41,38,0.06)',
    }}
  >
    <Box sx={{ maxWidth: 900, mx: 'auto' }}>
      <Typography
        id="local-seo-heading"
        component="h2"
        sx={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: { xs: '1.75rem', md: '2.25rem' },
          fontWeight: 600,
          color: 'var(--color-charcoal)',
          mb: 2,
          textAlign: 'center',
        }}
      >
        Resort &amp; rooms in Sholayar Dam — minutes from Valparai
      </Typography>
      <Typography
        sx={{
          color: 'var(--color-warm-gray)',
          fontSize: '1rem',
          lineHeight: 1.85,
          textAlign: 'center',
          mb: 2,
        }}
      >
        Looking for the <strong>best resort or hotel rooms in Sholayar</strong> or a peaceful{' '}
        <strong>Valparai hill-station stay</strong>? {businessInfo.name} offers comfortable{' '}
        <strong>accommodation near Valparai tea estates</strong> and the Sholayar reservoir area — ideal
        if you searched for a <strong>guest house in Valparai</strong>,{' '}
        <strong>Sholayar Dam resort</strong>, or <strong>family rooms between Valparai and Athirappilly</strong>.
        We welcome travellers who compare <strong>hotels in Valparai</strong> and want a quieter base on{' '}
        <strong>EB Road, Sholayar Dam (P.O)</strong>, Valparai <strong>642125</strong>, Tamil Nadu.
      </Typography>
      <Typography
        sx={{
          color: 'var(--color-warm-gray)',
          fontSize: '0.95rem',
          lineHeight: 1.8,
          textAlign: 'center',
        }}
      >
        Whether you need a <strong>budget-friendly room in Valparai</strong>, a{' '}
        <strong>couple-friendly resort near Sholayar</strong>, or a stop after{' '}
        <strong>Valparai hairpin routes</strong> and wildlife viewpoints, book your stay at{' '}
        {businessInfo.name} — <strong>resort and room booking online</strong> for your next trip to{' '}
        <strong>Sholayar Dam City</strong> and the <strong>Anaimalai / Western Ghats</strong> region.
      </Typography>
    </Box>
  </Box>
);

export default LocalSeoSection;
